import { render, staticRenderFns } from "./BlockEconWhereyear.vue?vue&type=template&id=3ee4190f&scoped=true&"
import script from "./BlockEconWhereyear.vue?vue&type=script&lang=js&"
export * from "./BlockEconWhereyear.vue?vue&type=script&lang=js&"
import style0 from "./BlockEconWhereyear.vue?vue&type=style&index=0&id=3ee4190f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4190f",
  null
  
)

export default component.exports